module.exports = __webpack_public_path__ + "static/media/404-image-with-text.18669fc1.webp";